import { render, staticRenderFns } from "./HeadlineLabels.vue?vue&type=template&id=74ea3620"
import script from "./HeadlineLabels.vue?vue&type=script&lang=ts"
export * from "./HeadlineLabels.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineLabels.vue?vue&type=style&index=0&id=74ea3620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports